<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="localValue"
      :total-items="localPagination.totalItems"
      hide-actions
      disable-initial-sort
      :loading="loading"
    >
      <template #items="{ item, index }">
        <td class="text-xs-right">
          {{ startIndex + index }}
        </td>
        <td>
          {{ item.username }}
        </td>
        <td>
          <v-btn small outline color="primary" @click="$emit('edit:password', item)">
            {{ $t('Change Password') }}
          </v-btn>
        </td>
        <td>
          <v-btn
            v-if="item.isConnected"
            small
            depressed
            color="error"
            @click="$emit('edit:isConnected', item, false)"
          >
            {{ $t('asset_wise.disconnect') }}
          </v-btn>
          <template v-else>-</template>
        </td>
        <td class="text-no-wrap">
          <v-btn small outline icon color="primary" @click="$emit('edit', item)">
            <v-icon small>edit</v-icon>
          </v-btn>
          <v-btn small outline icon color="primary" @click="$emit('remove', item)">
            <v-icon small>delete</v-icon>
          </v-btn>
        </td>
      </template>
    </v-data-table>
    <v-layout v-if="totalPages > 0" class="mt-3">
      <v-spacer />
      <v-pagination
        v-model="localPagination.page"
        :length="totalPages"
        @input="$emit('update:pagination', localPagination)"
      />
    </v-layout>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    pagination: {
      type: Object,
      default: undefined
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      localValue: JSON.parse(JSON.stringify(this.value)),
      localPagination: {
        page: 1,
        rowsPerPage: 5,
        totalItems: 0,
        ...this.pagination
      },
      headers: [
        { text: this.$t('no.'), align: 'right', sortable: false },
        { value: 'username', text: this.$t('asset_wise.username'), sortable: false },
        { text: this.$t('password'), sortable: false },
        { value: 'isConnected', text: this.$t('asset_wise.disconnect'), sortable: false },
        { text: this.$t('Action'), sortable: false }
      ]
    }
  },
  computed: {
    totalPages() {
      const { totalItems, rowsPerPage } = this.localPagination
      return Math.ceil(totalItems / rowsPerPage)
    },
    startIndex() {
      const { page, rowsPerPage } = this.localPagination
      return (page - 1) * rowsPerPage + 1
    }
  },
  watch: {
    value(value) {
      this.localValue = JSON.parse(JSON.stringify(value))
    },
    pagination(value) {
      this.localPagination = { ...this.localPagination, ...value }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/AssetWise/ExecutiveManagement/DataTable.vue